/* eslint-disable no-nested-ternary */
import React, { useState, useRef, useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import styled from '@emotion/styled';
import PropTypes from 'prop-types';
import Webcam from 'react-webcam';

import Spinner from '../../../../shared/_TBComponents/Spinner';
import NoHoverButton from '../../../../shared/components/NoHoverButton';

import { setSubActiveReduxModal } from '../../ducks/feedActions';

const ImageContainer = styled('div')`
  width: 700px;
  height: 395px;
  display: flex;
  align-items: center;
`;

const SpinnerWrapper = styled('div')`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 700px;
  height: 395px;
`;

const WebcamContainer = styled('div')`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  .text {
    font-size: 26px;
    font-weight: 300;
  }
  .capture-button {
    width: 180px;
    background-color: ${(props) => props.theme.colors.green};
    color: #ffffff;

    &:hover {
      opacity: 0.7;
    }
  }
`;

const videoConstraints = {
  width: 1280,
  height: 720,
  facingMode: 'user',
};

const WebcamCaptureImage = ({ handleUploadMedia }) => {
  const dispatch = useDispatch();
  const webcamRef = useRef(null);
  const [isCaptured, setIsCaptured] = useState(false);

  const currentUser = useSelector((state) => state.auth.data.currentUser);
  const uploadMedia = useSelector((state) => state.feed.data.uploadMedia);
  const isMediaLoading = useSelector((state) => state.feed.ui.isMediaLoading);

  const handleCaptureImage = useCallback(() => {
    const imageSrc = webcamRef.current.getScreenshot();
    const imageBuff = Buffer.from(
      imageSrc.replace(/^data:image\/\w+;base64,/, ''),
      'base64',
    );
    const image = new File([imageBuff], 'jpg', {
      type: 'image/jpeg',
    });
    const imgArray = [image];
    setIsCaptured(true);
    handleUploadMedia({
      accountCode: currentUser.accountCode,
      acceptedFile: imgArray,
      type: 'image',
    });
  }, [webcamRef]);

  const handleDoneClick = () => {
    dispatch(setSubActiveReduxModal(''));
  };

  const renderButton = () => {
    const baseProps = {
      className: 'modal-button',
      customColor: '#10cd8c',
      noHover: true,
      noBorder: true,
      bottom: true,
      fullWidth: true,
      large: true,
      primary: true,
      square: true,
    };

    const buttonConfig = isCaptured
      ? { cta: 'Done', onClick: handleDoneClick }
      : { cta: 'Take Photo', onClick: handleCaptureImage };

    return <NoHoverButton {...baseProps} {...buttonConfig} />;
  };

  const renderPlayer = () => {
    if (isCaptured) {
      if (uploadMedia && uploadMedia.mediaUrl && !isMediaLoading) {
        return (
          <ImageContainer>
            <img alt='' src={uploadMedia.mediaUrl} />
          </ImageContainer>
        );
      }
      return (
        <SpinnerWrapper>
          <Spinner />
        </SpinnerWrapper>
      );
    }
    return (
      <Webcam
        audio={false}
        width={700}
        height={395}
        ref={webcamRef}
        screenshotFormat='image/jpeg'
        videoConstraints={videoConstraints}
        screenshotQuality={1}
      />
    );
  };

  return (
    <WebcamContainer>
      {renderPlayer()}
      {renderButton()}
    </WebcamContainer>
  );
};

WebcamCaptureImage.propTypes = {
  handleUploadMedia: PropTypes.func.isRequired,
};

export default WebcamCaptureImage;
